import { render, staticRenderFns } from "./DialogConfirm.vue?vue&type=template&id=3b586220"
import script from "./DialogConfirm.vue?vue&type=script&lang=js"
export * from "./DialogConfirm.vue?vue&type=script&lang=js"
import style0 from "./DialogConfirm.vue?vue&type=style&index=0&id=3b586220&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports